import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classnames from 'classnames'

import { ReactComponent as CloudSaveIcon } from '../../../../../../assets/icons/cloud-saved.svg'

import { getDaysDiffLabel } from '../../../../../../forms/Multiplatform/MediaOrderForms/ContractBuilder/helpers'

import { clearUpdateContract } from '../../../../../../modules/actions/contracts'
import {
  activeContractSelector,
  updateContractErrorSelector,
  updateContractIsLoadingSelector
} from '../../../../../../modules/selectors/contracts'

import useStyles from './styles'

function SaveDataDetails() {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [hasError, setHasError] = React.useState(false)

  const activeContract = useSelector(activeContractSelector)
  const updateContractError = useSelector(updateContractErrorSelector)
  const updateContractIsLoading = useSelector(updateContractIsLoadingSelector)

  useEffect(() => {
    if (updateContractIsLoading) {
      setHasError(false)
    }
  }, [updateContractIsLoading])

  useEffect(() => {
    if (updateContractError) {
      setHasError(true)
      dispatch(clearUpdateContract())
    }
  }, [dispatch, updateContractError])

  return (
    <ul className={classes.saveDetailsContainer}>
      <li className={classes.detail}>Created: {getDaysDiffLabel(activeContract?.created)}</li>
      <li className={classes.detail}>Last updated: {getDaysDiffLabel(activeContract?.modified)}</li>
      <li
        className={classnames(classes.detail, {
          [classes.saveError]: hasError
        })}
      >
        <CloudSaveIcon
          className={classnames(classes.saveIcon, {
            [classes.saveIconLoading]: updateContractIsLoading
          })}
        />{' '}
        {hasError ? 'Save failed' : updateContractIsLoading ? 'Saving...' : 'Saved'}
      </li>
    </ul>
  )
}

export default SaveDataDetails
